<template>
  <div>
    <CreateAn2 :planData="planData"></CreateAn2>
    <div class="createrAn-Buttom-box">
      <div class="right intro-x">
          <div class="span1">
            <div>
              <span style="font-size: 18px; color: #333333">预估合计：</span>
              <span style="font-size: 18px; color: #ff4242">{{ predictNum }}元</span>
            </div>
            <div>已选 <span style="color: #1890ff">{{ labelNum }}</span> 个功能</div>
          </div>
      </div>
      <div class="createrAn-Buttom intro-x">
        <span class="span0 span1" @click="handlePrev">
          上一步
        </span>
        <el-button class="span0 span2" style="border: none; vertical-align: middle; line-height: 13px" @click="handleNext">
          下一步
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateAn2 from './createAn2'
import { calcBySupplyChain } from '@/api/supply-chain/supply-chain'

export default {
  components: { CreateAn2 },
  props: ["planData"],
  data() {
    return {
      labelNum: 0,
      predictNum: 0,
    }
  },
  mounted() {
    this.getLabelNum()
    this.getCalc()
  },
  methods: {
    handleNext() {
      this.$emit('handle-next')
    },
    handlePrev() {
      this.$emit('handle-prev')
    },
    // 计算选中的功能
    getLabelNum() {
      this.planData.forEach(item => {
        if (item.modules) {
          item.modules.forEach(subItem => {
            if (subItem.optional === '0') {
              this.labelNum++
            }
          })
        }
      })
    },
    // 后端计算价格
    async getCalc() {
      const params = {}
      params.pay_way = 1
      params.plan = []
      this.planData.forEach(item => {
        const pushItem = {}
        pushItem.id = item.plan_id
        pushItem.ext_modules = []
        if (item.modules) {
          item.modules.forEach(subItem => {
            if (subItem.optional === '0') {
              pushItem.ext_modules.push(subItem.mod_id)
            }
          })
        }
        params.plan.push(pushItem)
      })
      calcBySupplyChain(params).then(resp => {
        this.predictNum = resp.data.price
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}
</style>